import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, VideoIcon, GiftIcon, CalendarIcon, CheckCircle2Icon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ReviewsGallery } from '../components/ReviewsGallery';
import { EnrollmentOffer } from '../components/EnrollmentOffer';
import { FAQSection } from '../components/FAQSection';
export function EvaluationPage() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="pt-[64px] md:pt-[72px]" data-id="element-1128">
      {/* SECȚIUNEA 1 — HERO */}
      <section className="bg-brand-beige section-padding" data-id="element-1129">
        <div className="container-custom" data-id="element-1130">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1131">
            <span className="inline-block px-4 py-1.5 rounded-full bg-brand-coral/10 text-brand-coral font-montserrat font-bold text-[12px] tracking-wider uppercase mb-6" data-id="element-1132">
              EVALUARE ONLINE
            </span>
            <h1 className="font-playfair text-[40px] md:text-[56px] font-bold text-brand-navy mb-6 leading-tight" data-id="element-1133">
              Evaluare + Plan de intervenție pentru copilul tău
            </h1>
            <p className="font-source text-[18px] text-brand-textSecondary mb-10 max-w-3xl mx-auto" data-id="element-1134">
              O evaluare online în care analizez comportamentul real al
              copilului tău, din filmulețe făcute acasă, nu într-un cabinet unde
              totul arată diferit. Primești un raport de evaluare complet și un
              plan personalizat de prevenție sau recuperare, adaptat exact
              situației lui.
            </p>

            <div className="bg-white p-6 rounded-[24px] shadow-sm border border-gray-100 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mb-10 text-left" data-id="element-1135">
              <div className="flex flex-col gap-2" data-id="element-1136">
                <ClockIcon className="text-brand-coral" size={24} data-id="element-1137" />
                <p className="font-montserrat font-bold text-[14px] text-brand-navy" data-id="element-1138">
                  Durată
                </p>
                <p className="font-source text-[13px] text-brand-textSecondary" data-id="element-1139">
                  45 minute (ședința online) + analiză video în avans
                </p>
              </div>
              <div className="flex flex-col gap-2" data-id="element-1140">
                <VideoIcon className="text-brand-coral" size={24} data-id="element-1141" />
                <p className="font-montserrat font-bold text-[14px] text-brand-navy" data-id="element-1142">
                  Format
                </p>
                <p className="font-source text-[13px] text-brand-textSecondary" data-id="element-1143">
                  Online, pe Zoom. Înainte de întâlnire, îmi trimiți filmulețe
                  cu copilul din viața de zi cu zi.
                </p>
              </div>
              <div className="flex flex-col gap-2" data-id="element-1144">
                <GiftIcon className="text-brand-coral" size={24} data-id="element-1145" />
                <p className="font-montserrat font-bold text-[14px] text-brand-navy" data-id="element-1146">
                  Preț
                </p>
                <p className="font-source text-[13px] text-brand-textSecondary" data-id="element-1147">
                  <span className="line-through mr-2" data-id="element-1148">1.000 lei</span>
                  <span className="font-bold text-brand-coral" data-id="element-1149">750 lei</span>
                </p>
              </div>
              <div className="flex flex-col gap-2" data-id="element-1150">
                <CalendarIcon className="text-brand-coral" size={24} data-id="element-1151" />
                <p className="font-montserrat font-bold text-[14px] text-brand-navy" data-id="element-1152">
                  Disponibilitate
                </p>
                <p className="font-source text-[13px] text-brand-textSecondary" data-id="element-1153">
                  Programări limitate lunar
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center gap-3" data-id="element-1154">
              <a href="#inscriere" className="btn-primary" data-id="element-1155">
                Click aici pentru înscriere!
              </a>
              <p className="font-source text-[14px] text-brand-textSecondary" data-id="element-1156">
                Locuri limitate. Evaluarea se face online, iar raportul îl
                primești în 48 de ore.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 2 — ACEASTĂ EVALUARE ESTE PENTRU TINE DACĂ... */}
      <section className="bg-brand-ivory section-padding" data-id="element-1157">
        <div className="container-custom" data-id="element-1158">
          <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-brand-navy text-center mb-12" data-id="element-1159">
            Pentru cine este Ședința de Evaluare?
          </h2>
          <div className="max-w-4xl mx-auto bg-white p-8 md:p-12 rounded-[24px] shadow-sm" data-id="element-1160">
            <h3 className="font-playfair text-[24px] md:text-[28px] font-bold text-brand-navy mb-8 text-center" data-id="element-1161">
              Programează evaluarea dacă te regăsești în cel puțin una din
              aceste situații:
            </h3>
            <ul className="space-y-4" data-id="element-1162">
              {['Copilul tău are între 1 și 4 ani și nu vorbește sau spune doar câteva cuvinte pe care le înțelegi doar tu', 'Ai observat că e diferit de ceilalți copii de aceeași vârstă, dar nu știi dacă e motiv de îngrijorare sau doar o variație normală', 'Copilul a fost expus mult la ecrane și acum vezi că nu răspunde când îl strigi, nu te privește sau nu se joacă cu jucăriile', 'A primit un diagnostic (autism, întârziere în dezvoltare) și nu știi care e următorul pas sau ce poți face tu acasă', 'Ai tot amânat o evaluare pentru că te sperie ce ai putea afla, dar simți că nu mai poți aștepta', 'Ai fost la o evaluare în centru, dar simți că rezultatele nu reflectă ce vezi tu acasă, pentru că acolo copilul se comportă diferit'].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-1163">
                  <CheckCircle2Icon className="text-brand-coral flex-shrink-0 mt-0.5" size={24} data-id="element-1164" />
                  <span className="font-source text-[16px] md:text-[18px] text-brand-text" data-id="element-1165">
                    {item}
                  </span>
                </li>)}
            </ul>
            <div className="mt-10 text-center" data-id="element-1166">
              <a href="#inscriere" className="btn-primary inline-block" data-id="element-1167">
                Click aici pentru înscriere!
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 3 — CUM DECURGE EVALUAREA */}
      <section className="bg-brand-navy section-padding text-white" data-id="element-1168">
        <div className="container-custom" data-id="element-1169">
          <div className="max-w-4xl mx-auto" data-id="element-1170">
            <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-white mb-12 text-center" data-id="element-1171">
              Cum decurge evaluarea, pas cu pas
            </h2>

            <div className="space-y-8 mb-12" data-id="element-1172">
              {[{
              title: 'Îmi trimiți filmulețe cu copilul tău',
              desc: 'Filmezi câteva momente din viața de zi cu zi: joacă, masă, interacțiune cu tine, momente în care îi ceri ceva. Nu trebuie să fie filmat profesionist. Important e să văd comportamentul real, acasă, nu într-un cabinet unde copilul se comportă diferit.'
            }, {
              title: 'Analizez în detaliu fiecare filmulet',
              desc: 'Înainte de întâlnirea noastră, vizionez fiecare filmulet și evaluez dezvoltarea copilului pe toate ariile care contează: limbaj, joc, relaționare, emoții, comportament și autonomie. Nu mă bazez pe o singură ședință de 30 de minute în care copilul poate fi obosit, speriat sau pur și simplu într-o zi mai proastă.'
            }, {
              title: 'Ne vedem online și îți explic totul',
              desc: 'În ședința de 45 de minute pe Zoom, îți prezint ce am observat, ce e în parametri normali și ce necesită atenție. Îți răspund la toate întrebările. Nu te sperii, nu exagerez, nu minimizez. Îți spun exact ce văd, clar și pe înțelesul tău.'
            }, {
              title: 'Primești raportul și planul personalizat',
              desc: 'În maxim 48 de ore primești pe email sau WhatsApp raportul complet de evaluare și un plan personalizat de intervenție întocmit de mine și echipa mea. Știi exact ce să faci, în ce ordine și când e momentul să ceri ajutor suplimentar.'
            }].map((step, i) => <div key={i} className="flex flex-col md:flex-row gap-6 bg-white/5 p-8 rounded-[24px] border border-white/10" data-id="element-1173">
                  <div className="w-16 h-16 rounded-full bg-brand-gold text-brand-navy flex items-center justify-center flex-shrink-0 font-playfair font-bold text-[24px]" data-id="element-1174">
                    {i + 1}
                  </div>
                  <div data-id="element-1175">
                    <h3 className="font-montserrat font-bold text-[20px] text-brand-gold mb-3" data-id="element-1176">
                      {step.title}
                    </h3>
                    <p className="font-source text-[16px] text-white/90" data-id="element-1177">
                      {step.desc}
                    </p>
                  </div>
                </div>)}
            </div>

            <div className="text-center" data-id="element-1178">
              <p className="font-source text-[18px] text-white/90 italic mb-8" data-id="element-1179">
                Fără presiune de vânzare. Fără speriat inutil. Doar claritate și
                un plan concret pe care îl poți aplica imediat, indiferent dacă
                alegi să lucrezi cu mine în continuare sau nu.
              </p>
              <a href="#inscriere" className="btn-inverted" data-id="element-1180">
                Click aici pentru înscriere!
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 4 — DE CE ONLINE */}
      <section className="bg-brand-beige section-padding" data-id="element-1181">
        <div className="container-custom" data-id="element-1182">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1183">
            <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-brand-navy mb-8" data-id="element-1184">
              De ce evaluez din filmulețe de acasă, nu la cabinet
            </h2>
            <div className="font-source text-[16px] md:text-[18px] text-brand-text space-y-6 text-left mb-10" data-id="element-1185">
              <p data-id="element-1186">
                Mulți părinți care au venit la centru mi-au spus același lucru:
                "Acasă face cu totul altfel." Și au dreptate.
              </p>
              <p data-id="element-1187">
                Când un copil mic intră într-un cabinet nou, cu o persoană
                necunoscută, într-un mediu pe care nu îl controlează, se
                comportă diferit. Poate fi mai retras, mai agitat, mai cooperant
                sau mai refractar decât acasă. O evaluare de 30 de minute în
                aceste condiții poate oferi o imagine parțială sau
                distorsionată.
              </p>
              <p data-id="element-1188">
                Când analizez filmulețe de acasă, văd copilul real: cum se joacă
                când e relaxat, cum interacționează cu tine, cum reacționează
                când îi ceri ceva, cum gestionează frustrarea în mediul lui
                natural. Asta îmi permite să fac o evaluare mai precisă și un
                plan care se potrivește cu adevărat situației voastre.
              </p>
            </div>
            <a href="#inscriere" className="btn-primary" data-id="element-1189">
              Click aici pentru înscriere!
            </a>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 5 — CINE SUNT EU */}
      <section className="bg-brand-ivory section-padding" data-id="element-1190">
        <div className="container-custom" data-id="element-1191">
          <div className="max-w-4xl mx-auto" data-id="element-1192">
            <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-brand-navy text-center mb-10" data-id="element-1193">
              Cine te va ghida în această evaluare
            </h2>
            <div className="flex flex-col-reverse md:grid md:grid-cols-3 gap-8 items-stretch" data-id="element-1194">
              <div className="md:col-span-2 font-source text-[16px] md:text-[18px] text-brand-text space-y-4 text-center md:text-left flex flex-col justify-center" data-id="element-1195">
                <p data-id="element-1196">
                  Sunt Cristina Geană, psiholog clinician cu peste 11 ani de
                  experiență directă cu copii mici. Am evaluat și coordonat
                  intervenția pentru sute de copii cu întârzieri în dezvoltare
                  și tulburări din spectrul autist.
                </p>
                <p data-id="element-1197">
                  Sunt formată în Analiză Comportamentală (ABA) la Universitatea
                  Clemson din SUA, atestată de Colegiul Psihologilor din România
                  și am zeci de cursuri în logopedie, terapie senzorială și
                  evaluarea copilului cu cerințe educative speciale.
                </p>
                <p className="font-bold text-brand-navy" data-id="element-1198">
                  O evaluare corectă la momentul potrivit poate schimba totul.
                  Știu ce înseamnă să fii mamă și să nu ai pe cineva care să îți
                  spună clar ce se întâmplă.
                </p>
              </div>
              <div className="md:col-span-1" data-id="element-1199">
                <img src="https://cdn.magicpatterns.com/uploads/wvUBHAy6VhqaRqNiVJPB6X/Cristina_poze_%285%29.jpg" alt="Cristina Geană" className="w-full h-full object-cover object-top rounded-[24px] shadow-card" data-id="element-1200" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 6 — OFERTĂ */}
      <EnrollmentOffer title="Ce primești și care este investiția ta" includes={['Analiză video detaliată a comportamentului copilului în mediul natural', 'Ședință online de 45 de minute pe Zoom', 'Raport de evaluare complet primit pe email sau WhatsApp', 'Plan personalizat de intervenție întocmit de mine și echipa mea']} oldPrice="1.000 lei" price="750 lei" savings="Economisești 250 lei" badge="Locuri limitate lunar" data-id="element-1201" />

      {/* SECȚIUNEA 7 — TESTIMONIALE */}
      <section className="bg-brand-beige section-padding" data-id="element-1202">
        <div className="container-custom" data-id="element-1203">
          <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-brand-navy text-center mb-12" data-id="element-1204">
            Ce spun mamele care au trecut prin evaluare
          </h2>
          <ReviewsGallery data-id="element-1205" />
        </div>
      </section>

      {/* SECȚIUNEA 8 — FAQ */}
      <FAQSection faqs={[{
      q: 'Cum trimit filmulețele?',
      a: 'După înscriere, vei primi instrucțiuni detaliate despre cum și unde să încarci filmulețele în siguranță.'
    }, {
      q: 'Cât de lungi trebuie să fie filmulețele?',
      a: 'În general, 3-4 filmulețe scurte (2-3 minute fiecare) din diferite momente ale zilei sunt suficiente.'
    }, {
      q: 'Copilul trebuie să fie prezent la ședința online?',
      a: 'Nu este obligatoriu. Putem discuta doar noi două, mai ales dacă prezența lui ar îngreuna discuția.'
    }]} data-id="element-1206" />

      {/* SECȚIUNEA 9 — ÎNSCRIERE */}
      <section id="inscriere" className="bg-brand-navy section-padding text-center text-white" data-id="element-1207">
        <div className="container-custom" data-id="element-1208">
          <div className="max-w-3xl mx-auto" data-id="element-1209">
            <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-white mb-6" data-id="element-1210">
              Nu mai amâna claritatea de care ai nevoie.
            </h2>
            <p className="font-source text-[18px] text-white/90 mb-10" data-id="element-1211">
              Cel mai rău lucru care se poate întâmpla este să pleci de la
              această evaluare cu o claritate totală: știi exact unde e copilul
              tău, ce e normal, ce necesită atenție și ce ai de făcut de mâine.
              Chiar dacă nu alegi să lucrezi cu mine după aceea, ai un plan clar
              pe care îl poți aplica singură, acasă.
            </p>

            <div className="bg-white rounded-[24px] overflow-hidden min-h-[600px]" data-id="element-1212">
              <iframe src="https://api.leadconnectorhq.com/widget/form/TRffF7xBe2ns6R3Wgsxc" style={{
              width: '100%',
              height: '100%',
              minHeight: '600px',
              border: 'none'
            }} id="inline-TRffF7xBe2ns6R3Wgsxc" data-layout="{'id':'INLINE'}" data-trigger-type="alwaysShow" data-trigger-value="" data-activation-type="alwaysActivated" data-activation-value="" data-deactivation-type="neverDeactivate" data-deactivation-value="" data-form-name="Form Evaluare" data-height="600" data-layout-iframe-id="inline-TRffF7xBe2ns6R3Wgsxc" data-form-id="TRffF7xBe2ns6R3Wgsxc" title="Form Evaluare" data-id="element-1213" />
            </div>
          </div>
        </div>
      </section>
    </motion.div>;
}